import ButtonMUI, { ButtonProps } from "@mui/material/Button";
import { SpacingProps } from "@mui/system";
import { useCallback } from "react";
export type MUIButtonProps = {
  label?: string;
  onClick?: () => any;
};

export const Button = (props: MUIButtonProps & ButtonProps & SpacingProps) => {
  const { onClick, label } = props;
  const onClickButton = useCallback(() => {
    onClick && onClick();
  }, [onClick]);

  return (
    <ButtonMUI {...props} onClick={() => onClickButton()} variant="contained">
      {label}
    </ButtonMUI>
  );
};
